import i18next from 'i18next'
import React from 'react'
import { useInView } from '../../../../../utils/hooks/hooks/useInView'
import { Image, ImageBase, ImageOptions } from '../../../../../utils/images'
import { mediaBlockClasses, mediaBlockNestedClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { Video } from '../../../../components/video'
import { CookiePlaceholderLayout } from '../../../../cookiebar/cookiebarLayout'
import { InviewProps } from '../../blocksState'

export type MediaBlockNested = {
  index: number
  items: MediaItemNestedProps[]
  inview?: InviewProps
}

export type MediaItemNestedProps = {
  kind: 'image' | 'video'
  image?: ImageBase & ImageOptions
  video?: {
    url: string
    id: string
    type: string
  }
  caption?: string
  source?: string
  author?: string
}

export type MediaBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  figureClassName: string
  figureImageClassName: string
  figureVideoClassName: string
  mediaClassName: string
  imageClassName: string
  imageNonExpandableClassName: string
  pictureClassName: string
  videoClassName: string
  figCaptionClassName: string
  captionClassName: string
  sourceClassName: string
  cookiesClassName: string
  cookiesInnerClassName: string
  cookiesTextClassName: string
  cookiesClickableClassName: string
}>

export const MediaBlockNestedLayout = (
  props: MediaBlockNested & {
    videoCookieAccepted: boolean
    acceptVideoCookie: () => void
  }
) => {
  const { inview, index, items, videoCookieAccepted, acceptVideoCookie } = props
  const classes = mediaBlockNestedClasses
    const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("MediaBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')

  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(mediaBlockNestedClasses, 'innerClassName', 'py-3')}>
        {items && items.length > 0 && (
          <div className={getClassName(mediaBlockNestedClasses, 'contentClassName', 'content')}>
            {items.map((item: MediaItemNestedProps, i: number) => {
              return (
                <figure
                  key={`media-${index}-${i}`}
                  className={`${getClassName(
                    mediaBlockNestedClasses,
                    'figureClassName',
                    'mb-0'
                  )}
                        ${getClassName(
                    mediaBlockNestedClasses,
                    item.kind === 'image'
                      ? 'figureImageClassName'
                      : 'figureVideoClassName',
                    ''
                  )}
                      `}
                >
                  {item.kind === 'image'
                    ? item.image && (
                      <div
                        className={getClassName(
                          mediaBlockNestedClasses,
                          'mediaClassName',
                          ''
                        )}
                      >
                        <Image
                          {...item.image}
                          classNames={{
                            image: getClassName(
                              mediaBlockNestedClasses,
                              (item.image?.keepOriginalSize ? 'imageNonExpandableClassName' : 'imageClassName'),
                              'w-100'
                            ),
                            picture: getClassName(
                              mediaBlockNestedClasses,
                              'pictureClassName',
                              ''
                            )
                          }}
                        />
                      </div>
                    )
                    : item.kind === 'video' &&
                    item.video !== undefined && (
                      <div
                        className={getClassName(
                          mediaBlockNestedClasses,
                          'mediaClassName',
                          'text-center'
                        )}
                      >
                        {!videoCookieAccepted
                          ? (<CookiePlaceholderLayout onAccept={acceptVideoCookie} />)
                          : <Video
                            url={item?.video?.url}
                            videoCookieAccepted={videoCookieAccepted}
                            acceptVideoCookie={acceptVideoCookie}
                            className="figure__video"
                          />
                        }
                      </div>
                    )}

                  {(item.caption || item.author) && (
                    <figcaption
                      className={getClassName(
                        mediaBlockNestedClasses,
                        'figCaptionClassName',
                        'mt-2'
                      )}
                    >
                      {item.caption && (
                        <p
                          className={getClassName(
                            mediaBlockNestedClasses,
                            'captionClassName',
                            'small text-secondary text-center m-0'
                          )}
                        >
                          {item.caption}
                        </p>
                      )}
                      {item.author && (
                        <p
                          className={getClassName(
                            mediaBlockClasses,
                            'sourceClassName',
                            'small text-secondary text-center m-0'
                          )}
                        >
                          {i18next.t('media:by_author', {
                            author: item.author
                          })}
                        </p>
                      )}
                    </figcaption>
                  )}
                </figure>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
